<template>
  <div>
    <v-select v-model="odabranaUsluga"
              :items="PopisUsluga"
              item-text="Ime"
              return-object
              item-value="rbr"
              @change="odabir(odabranaUsluga)"
              :label="$t('documents.upload.available_services')"></v-select>
  </div>
</template>

<script>
  export default {
    name: 'SelectEducation',

    props: {
      PopisUsluga: { type: Array },
      odabir: { type: Function },
    },
    computed: {
      //odabranaUslugaComp() {
      //  return this.PopisUsluga.filter(x => x.UpisPO_ID == this.odabranaUslugaKljuc)[0];
      //}
    },

    data() {
      return {
        odabranaUsluga: {
         // return-object kaže da ćemo vratiti cijeli objekt
        }

      }
    },

    mounted() {
      
    },

    methods: {

    }

  }
</script>



// WEBPACK FOOTER //
// VueSrc/Exams/presence_exam_results/SelectEducation.vue